<div class="header-dots">
  <div class="btn-group" ngbDropdown autoClose="outside" placement="bottom" (shown)="updateNotificacoes()">

    <button type="button" class="btn btn-link p-0 mr-2" (click)="openManual()" title="Manual do Sistema">
      <span>
        <div class="icon-wrapper icon-wrapper-alt rounded-circle">
          <div class="icon-wrapper-bg bg-warning"></div>
          <i class="lnr-book text-warning"></i>
        </div>
      </span>
    </button>

    <button type="button" class="btn btn-link p-0" (click)="updateNotificacoes()" ngbDropdownToggle
      title="Notificações">
      <span>
        <div class="icon-wrapper icon-wrapper-alt rounded-circle">
          <div class="icon-wrapper-bg bg-warning"></div>
          <i class="lnr-bullhorn text-warning"></i>
          <div class="badge badge-dot badge-dot-sm badge-warning">Notficações</div>
        </div>
      </span>
    </button>
    <div class="dropdown-menu-xl" ngbDropdownMenu>
      <div class="dropdown-menu-header mb-0">
        <div class="dropdown-menu-header-inner bg-deep-blue">
          <div class="menu-header-image opacity-1 dd-header-bg-2"></div>
          <div class="menu-header-content text-dark">
            <h5 class="menu-header-title">Notificações</h5>
            <h6 class="menu-header-subtitle">Você tem mensagens não lidas</h6>
          </div>
        </div>
      </div>
      <div class="card-tabbed-header">
        <ngb-tabset class="tabs-animated tabs-animated-shadow" justify="justified">
          <ngb-tab>
            <ng-template ngbTabTitle><span>Mensagens</span></ng-template>
            <ng-template ngbTabContent>
              <div class="scroll-gradient">
                <div class="scroll-area-sm ">
                  <perfect-scrollbar [autoPropagation]="true">
                    <div
                      class="vertical-time-simple vertical-without-time vertical-timeline vertical-timeline--animate vertical-timeline--one-column">
                      <div class="vertical-timeline-item vertical-timeline-element">
                        <div><span class="vertical-timeline-element-icon bounce-in"></span>
                          <div class="vertical-timeline-element-content bounce-in">
                            <h4 class="timeline-title" [innerHTML]="notificacaoSS"></h4>
                            <span class="vertical-timeline-element-date"></span>
                          </div>
                        </div>
                      </div>
                      <div class="vertical-timeline-item vertical-timeline-element">
                        <div><span class="vertical-timeline-element-icon bounce-in"></span>
                          <div class="vertical-timeline-element-content bounce-in">
                            <h4 class="timeline-title" [innerHTML]="notificacaoOS"></h4>
                            <span class="vertical-timeline-element-date"></span>
                          </div>
                        </div>
                      </div>
                      <div class="vertical-timeline-item vertical-timeline-element">
                        <div><span class="vertical-timeline-element-icon bounce-in"></span>
                          <div class="vertical-timeline-element-content bounce-in">
                            <h4 class="timeline-title" [innerHTML]="notificacaoVistoExecucao"></h4>
                            <span class="vertical-timeline-element-date"></span>
                          </div>
                        </div>
                      </div>
                      <div class="vertical-timeline-item vertical-timeline-element">
                        <div><span class="vertical-timeline-element-icon bounce-in"></span>
                          <div class="vertical-timeline-element-content bounce-in">
                            <h4 class="timeline-title" [innerHTML]="notificacaoOSValidada"></h4>
                            <span class="vertical-timeline-element-date"></span>
                          </div>
                        </div>
                      </div>

                    </div>
                  </perfect-scrollbar>
                </div>
              </div>
            </ng-template>
          </ngb-tab>

        </ngb-tabset>
      </div>
      
    </div>
  </div>

</div>